<template>
	<section>
		<!--el-tabs class="welcome_tab" type="border-card">
            <div class="welcome-prompt"> {{ $t("alexa.console_welcome_prompt") }} </div>
		</el-tabs-->
		<el-form class="box" style="text-align:center;">
			<img src="../assets/console2.png" class="logo">
		</el-form>
		<el-form class="box2" style="text-align:center;">
			<h2 class="welcome-prompt">{{ $t("alexa.console_welcome_prompt") }}</h2>
		</el-form>
	</section>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Welcome',
    computed: mapState({
        user: state => state.user
    }),
    components: {

    },
	methods: {
        updateHeader() {
            document.getElementById("title_username").innerHTML = this.user.email;
        },
	},
    mounted() {
        this.updateHeader();
    },
}
</script>
<style scoped>
	.logo{
		width: 120px;
		margin: 10px 10px 10px 18px;
	}

</style>




// WEBPACK FOOTER //
// src/components/Welcome.vue